import { useState } from "react";
import "../../Styles/Modal.css";
import { ImCancelCircle } from "react-icons/im";
import axios from "axios";
import { CircularProgress } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import Swal from "sweetalert2";

const AddBranch = ({ handleAddBranch }: any) => {
  const [branch, setBranch] = useState({
    name: "",
    state: "",
    city: "",
    address: "",
    phone: ""
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setBranch((prevBranch) => ({
      ...prevBranch,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(
        "https://apibiz.oneflaretech.com/api/branch",
        branch,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`
          }
        }
      );
      Swal.fire({
        title: "Success!",
        text: "Branch created successfully!",
        icon: "success",
        confirmButtonText: "OK",
        confirmButtonColor: "green"
      });
      handleAddBranch(); // Close the modal after successful submission
      setLoading(false);
      setBranch({ name: "", state: "", city: "", address: "", phone: "" }); // Reset form fields
      setTimeout(() => {
        window.location.reload();
      }, 3500); 
    } catch (error) {
      console.error("Error creating branch:", error);
      toast.error("Failed to create branch. Please try again.");
      setLoading(false);
    }
  };

  return (
    <div className="modal">
      <ToastContainer />
      <form onSubmit={handleSubmit} className="catModal">
        <div className="catModalTop">
          <h4>Add New Branch</h4>
          <ImCancelCircle className="catCancel" onClick={handleAddBranch} />
        </div>
        <div className="line"></div>

        <div className="catModalInput branchInput">
          <input
            type="text"
            placeholder="Branch name"
            name="name"
            required
            value={branch.name}
            onChange={handleChange}
          />
          <div className="div modalDouble">
            <input
              type="text"
              placeholder="Branch State"
              name="state"
              required
              value={branch.state}
              onChange={handleChange}
            />
            <input
              type="text"
              placeholder="Branch City"
              name="city"
              required
              value={branch.city}
              onChange={handleChange}
            />
          </div>
          <input
            type="text"
            placeholder="Branch Address"
            name="address"
            required
            value={branch.address}
            onChange={handleChange}
          />
          <input
            type="text"
            placeholder="Branch Phone number"
            name="phone"
            required
            value={branch.phone}
            onChange={handleChange}
          />
        </div>
        <div className="catModalBtn">
          <button className="catBtn1" type="submit" disabled={loading}>
            {loading ? (
              <CircularProgress
                style={{ color: "#fff", width: "25px", height: "25px" }}
              />
            ) : (
              "Create"
            )}
          </button>
          <button className="catBtn2" type="button" onClick={handleAddBranch}>
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddBranch;
